import moment from 'moment';

/**
 * Action item start/due dates are stored as Unix seconds at UTC midnight
 * (see Activity::setStartDate / setDueDate).
 */

/** Values above this are treated as milliseconds (API / legacy clients). */
const UNIX_SECONDS_UPPER_BOUND = 1e10;

export function normalizeToUnixSeconds(timestamp: number): number {
  return timestamp > UNIX_SECONDS_UPPER_BOUND
    ? Math.floor(timestamp / 1000)
    : timestamp;
}

export function utcUnixSecondsToPickerMoment(unixSeconds: number): moment.Moment {
  return moment.unix(unixSeconds).utc().startOf('day');
}

export function pickerDateToUtcUnixSeconds(date: Date): number {
  return moment
    .utc({
      year: date.getUTCFullYear(),
      month: date.getUTCMonth(),
      date: date.getUTCDate(),
    })
    .unix();
}
